/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum TagChangeDataOperationMethod {
    selected = 'selected',
    added = 'added',
    removed = 'removed'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const TagChangeDataOperationMethodValidatorShape = [
    'selected',
    'added',
    'removed'
];
export const TagChangeDataOperationMethodValidator = yup.mixed().oneOf(TagChangeDataOperationMethodValidatorShape);
export const TagChangeDataOperationMethodStringifyShapeProperties = {};
export const TagChangeDataOperationMethodStringifyShape: StringSchema = {
    title: 'TagChangeDataOperationMethod Stringifier',
    type: 'string'
};
export const TagChangeDataOperationMethodStringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(TagChangeDataOperationMethodStringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function TagChangeDataOperationMethodFromJSON(json: any): TagChangeDataOperationMethod {
    return TagChangeDataOperationMethodFromJSONTyped(json, false);
}
export function TagChangeDataOperationMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagChangeDataOperationMethod {
    return json as TagChangeDataOperationMethod;
}
export function TagChangeDataOperationMethodToJSON(value?: TagChangeDataOperationMethod | null): any {
    return value as any;
}
